import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { InterceptorService } from './services';
import { InputErrorsPipe } from './pipes';
import { ListFilterPipe } from './pipes/list-filter.pipe';

@NgModule({
  declarations: [
    InputErrorsPipe,
    ListFilterPipe
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    InputErrorsPipe,
    ListFilterPipe
  ],
  providers: [
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
  ],
})
export class CoreServicesModule { }
